module.exports = __webpack_public_path__ + "imgs/leaf411-hero.2806acc4041691c8e248261111977179.svg";